module.exports = __webpack_public_path__ + "static/img/5.c0ad880.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/8/2/sp/5.png
// module id = LUt9
// module chunks = 0